import { Interface } from '@ethersproject/abi';
import XPpayExchangeRate from './xppay-exchange-rate.json';

export const XPPAY_EXCHANGE_RATE_INTERFACE = new Interface(XPpayExchangeRate);
